import { render, staticRenderFns } from "./CategoryCardDescription.vue?vue&type=template&id=83ca52ca&scoped=true"
import script from "./CategoryCardDescription.vue?vue&type=script&lang=ts"
export * from "./CategoryCardDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ca52ca",
  null
  
)

export default component.exports